import axios from "./axios"

const getUploadFileFormat = async (data) => {
	// return await axios.get(`/info/formats`).then((data) => {
	// 	return data
	// })
	return
}

const uploadFiles = async (data, case_id) => {
	const formData = new FormData()
	data.forEach((file) => {
		formData.append("files", file)
	})

	return await axios
		.post(`/case/add_files?case_id=${case_id}&replace=false&universal_job=true&chunk_size=10240000`, formData)
		.then((data) => {
			return data
		})
}

const getUploadFileStatus = async () => {
	return await axios.get(`/case/continuous_upload`).then((data) => {
		return data
	})
}

export const uploadServices = {
	getUploadFileFormat,
	uploadFiles,
	getUploadFileStatus,
}
